export default __webpack_public_path__ + "static/media/Sunset-Edited-1920px-588px.e657ad8a.jpg";